import { Box, styled } from '@mui/material';

const FiltersRow = styled(Box)`
  display: flex;
  gap: 30px;
  margin: 30px 0 20px;
`;

export default FiltersRow;
